@switch (iconName) {
  @case (Icons.assetsTree) {
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 20 20">
      <path
        d="M17.4999 13.3333V10.8333C17.4999 9.90832 16.7583 9.16666 15.8333 9.16666H10.8333V6.66666H12.4999V1.66666H7.49992V6.66666H9.16658V9.16666H4.16658C3.24159 9.16666 2.49992 9.90832 2.49992 10.8333V13.3333H0.833252V18.3333H5.83325V13.3333H4.16658V10.8333H9.16658V13.3333H7.49992V18.3333H12.4999V13.3333H10.8333V10.8333H15.8333V13.3333H14.1666V18.3333H19.1666V13.3333H17.4999ZM9.16658 3.33332H10.8333V4.99999H9.16658V3.33332ZM4.16658 16.6667H2.49992V15H4.16658V16.6667ZM10.8333 16.6667H9.16658V15H10.8333V16.6667ZM17.4999 16.6667H15.8333V15H17.4999V16.6667Z"
        [attr.fill]="fill"
      />
    </svg>
  }
}
